import { render, staticRenderFns } from "./SaleGroupItem.vue?vue&type=template&id=08c53204&scoped=true&"
import script from "./SaleGroupItem.vue?vue&type=script&lang=js&"
export * from "./SaleGroupItem.vue?vue&type=script&lang=js&"
import style0 from "./SaleGroupItem.vue?vue&type=style&index=0&id=08c53204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c53204",
  null
  
)

export default component.exports